import { AssetType } from "./AssetType";
import { Unit } from "./Unit";
import { UserRole } from "./UserRole";
import { CertificateStatus } from "./CertificateStatus";
import { BlockchainExplorerUrl } from "./BlockchainExplorer";
import { SmartContractVersion } from "./SmartContractVersion";
import { OrganizationTypes } from "./OrganizationTypes";
import { ConsumptionTypes } from "./ConsumptionTypes";
import { MaintenanceActionTypes } from "./MaintenanceActionTypes";
import { MaintenanceOrganization } from "./MaintenanceOrganization";
import { DemoSources } from "./DemoSources";
import { FrequencyTypes } from "./FrequencyTypes";
import { CertificatesTypes } from "./CertificatesTypes";
import { CO2Equivalents } from "./CO2Equivalents";



export const enums = {
  AssetType,
  Unit,
  UserRole,
  CertificateStatus,
  BlockchainExplorerUrl,
  SmartContractVersion,
  OrganizationTypes,
  ConsumptionTypes,
  MaintenanceActionTypes,
  DemoSources,
  MaintenanceOrganization,
  FrequencyTypes,
  CertificatesTypes,
  CO2Equivalents
}



// WEBPACK FOOTER //
// ./src/enums/index.js